export type BrokerNerdsBarkerCoreEnumsSeatingType = (typeof BrokerNerdsBarkerCoreEnumsSeatingType)[keyof typeof BrokerNerdsBarkerCoreEnumsSeatingType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokerNerdsBarkerCoreEnumsSeatingType = {
  Unknown: 'Unknown',
  Consecutive: 'Consecutive',
  EvenOdd: 'EvenOdd',
  GeneralAdmission: 'GeneralAdmission',
} as const;
